module.exports = __webpack_public_path__ + "media/images/icon__point--white@3x-b8ecce866e5103248f8b7df18d28892e.png";